"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUtcShowtimeInFuture = void 0;
// @ts-nocheck
const dayjs_1 = __importDefault(require("dayjs"));
const utc = require('dayjs/plugin/utc');
dayjs_1.default.extend(utc);
dayjs_1.default.extend(require("dayjs/plugin/utc"));
dayjs_1.default.extend(require("dayjs/plugin/isSameOrAfter"));
const isUtcShowtimeInFuture = (date) => {
    // @ts-ignore
    const threeHoursAgo = dayjs_1.default.utc().subtract(3, "h");
    console.log("threeHoursAgo ", threeHoursAgo.toDate());
    // @ts-ignore
    let utc1 = dayjs_1.default.utc(date);
    console.log("to check ", utc1.toDate());
    return utc1.isSameOrAfter(threeHoursAgo);
};
exports.isUtcShowtimeInFuture = isUtcShowtimeInFuture;
//# sourceMappingURL=is-utc-showtime-in-future.js.map